import type { Key, PropsWithChildren } from "react";

import { AccordionProvider } from "./contexts/Accordion";

import type { AccordionProps } from ".";

/**
 * Accordion component that does not unmount child components, but only hides them.
 */
export function Accordion<ItemId extends Key>({
  children,
  openedItems,
}: PropsWithChildren<AccordionProps<ItemId>>) {
  return (
    <AccordionProvider openedItems={openedItems}>{children}</AccordionProvider>
  );
}
